import React from 'react';
import './BulkActionsPopup.css';

/**
 * BulkActionsPopup Component
 * 
 * A reusable floating popup that appears at the bottom of the screen
 * when items are selected, providing bulk action capabilities.
 */
export default function BulkActionsPopup({
  selectedRows,
  bulkActions = [],
  onClose,
  itemLabel = 'items'
}) {
  if (!selectedRows || selectedRows.size === 0) {
    return null;
  }

  const selectedCount = selectedRows.size;

  return (
    <div className="bulk-actions-popup">
      <div className="bulk-actions-content">
        <div className="selected-count">
          <i className="bi bi-check-square"></i>
          <span>{selectedCount} {itemLabel}{selectedCount !== 1 ? 's' : ''} selected</span>
        </div>
        
        <div className="bulk-actions-buttons">
          {bulkActions.map((action, index) => (
            <button
              key={index}
              className={action.className || "btn btn-secondary"}
              onClick={() => action.onClick(selectedRows)}
              disabled={action.disabled}
              title={action.label}
            >
              {action.icon && <i className={action.icon}></i>}
              <span className="btn-label">{action.label}</span>
            </button>
          ))}
          
          {onClose && (
            <button
              className="btn btn-outline-light btn-close-popup"
              onClick={onClose}
              title="Clear selection"
            >
              <i className="bi bi-x"></i>
            </button>
          )}
        </div>
      </div>
    </div>
  );
}